const translations: Record<string, { en: string; id: string }> = {
  // ──── Shipping Page ────
  "shipping.title": { en: "Shipping & Logistics", id: "Pengiriman & Logistik" },
  "shipping.subtitle": {
    en: "Reliable global logistics with FOB/CIF shipping, door-to-door delivery, and dedicated export documentation support for hassle-free international trade.",
    id: "Logistik global yang andal dengan pengiriman FOB/CIF, pengiriman door-to-door, dan dukungan dokumentasi ekspor untuk perdagangan internasional yang lancar.",
  },
  "shipping.global.title": { en: "Global Shipping Network", id: "Jaringan Pengiriman Global" },
  "shipping.global.desc": {
    en: "We ship worldwide via major international carriers including DHL, FedEx, UPS, and maritime freight. Our logistics network covers Asia Pacific, North America, Europe, Middle East, and Africa with reliable door-to-door delivery services.",
    id: "Kami mengirim ke seluruh dunia melalui operator internasional utama termasuk DHL, FedEx, UPS, dan angkutan laut. Jaringan logistik kami mencakup Asia Pasifik, Amerika Utara, Eropa, Timur Tengah, dan Afrika dengan layanan pengiriman door-to-door yang andal.",
  },
  "shipping.terms.title": { en: "Flexible Shipping Terms", id: "Ketentuan Pengiriman Fleksibel" },
  "shipping.terms.desc": {
    en: "We offer both FOB (Free On Board) and CIF (Cost, Insurance & Freight) shipping terms. FOB: buyer assumes responsibility once goods are on board vessel at our port. CIF: we handle shipping and insurance costs to the destination port. Please contact us to discuss the best option for your order.",
    id: "Kami menawarkan ketentuan pengiriman FOB (Free On Board) dan CIF (Cost, Insurance & Freight). FOB: pembeli bertanggung jawab setelah barang di atas kapal di pelabuhan kami. CIF: kami menangani biaya pengiriman dan asuransi ke pelabuhan tujuan. Silakan hubungi kami untuk mendiskusikan opsi terbaik untuk pesanan Anda.",
  },
  "shipping.docs.title": { en: "Export Documentation", id: "Dokumentasi Ekspor" },
  "shipping.docs.desc": {
    en: "We handle all export documentation including commercial invoice, packing list, bill of lading / airway bill, certificate of origin (for preferential tariff treatment), phytosanitary certificate, and fumigation certificate. We ensure full compliance with customs regulations for smooth international clearance.",
    id: "Kami menangani semua dokumentasi ekspor termasuk faktur komersial, daftar kemasan, bill of lading / airway bill, sertifikat asal (untuk perlakuan tarif preferensial), sertifikat fitosanitasi, dan sertifikat fumigasi. Kami memastikan kepatuhan penuh terhadap peraturan bea cukai untuk kelancaran izin internasional.",
  },
  "shipping.ports.title": { en: "Shipping Ports", id: "Pelabuhan Pengiriman" },
  "shipping.ports.desc": {
    en: "Main export ports: Tanjung Priok (Jakarta) – Indonesia's largest and busiest seaport, handling containerized cargo for all international destinations. Tanjung Perak (Surabaya) – primary port for East Java exports. Belawan (Medan) – gateway port for Sumatra exports. Our proximity to these major ports ensures efficient logistics and reduced transit times.",
    id: "Pelabuhan ekspor utama: Tanjung Priok (Jakarta) – pelabuhan terbesar dan tersibuk di Indonesia, menangani kargo kontainer untuk semua tujuan internasional. Tanjung Perak (Surabaya) – pelabuhan utama untuk ekspor Jawa Timur. Belawan (Medan) – pelabuhan gerbang untuk ekspor Sumatra. Kedekatan kami dengan pelabuhan-pelabuhan utama ini memastikan logistik yang efisien dan waktu transit yang lebih singkat.",
  },
  "shipping.transit.title": { en: "Transit Times & Tracking", id: "Waktu Transit & Pelacakan" },
  "shipping.transit.desc": {
    en: "Estimated transit times from Indonesia: Southeast Asia 3–5 days, East Asia 5–7 days, Middle East 7–10 days, Europe 14–21 days, North America 14–21 days, Africa 14–25 days. Every shipment includes real-time tracking so you can monitor your cargo from warehouse to destination.",
    id: "Perkiraan waktu transit dari Indonesia: Asia Tenggara 3–5 hari, Asia Timur 5–7 hari, Timur Tengah 7–10 hari, Eropa 14–21 hari, Amerika Utara 14–21 hari, Afrika 14–25 hari. Setiap pengiriman dilengkapi pelacakan real-time sehingga Anda dapat memantau kargo dari gudang hingga tujuan.",
  },
  "shipping.packaging.title": { en: "Packaging & Handling", id: "Pengemasan & Penanganan" },
  "shipping.packaging.desc": {
    en: "Products are professionally packed in food-grade packaging suitable for international freight. Options include vacuum-sealed bags, aluminum foil bags, food-grade HDPE drums, and export-grade cartons / pallets. All packaging meets international shipping standards to ensure product integrity during transit.",
    id: "Produk dikemas secara profesional dalam kemasan food-grade yang sesuai untuk angkutan internasional. Opsi termasuk kantong vakum, kantong aluminium foil, drum HDPE food-grade, dan karton/palet grade ekspor. Semua kemasan memenuhi standar pengiriman internasional untuk menjaga integritas produk selama transit.",
  },

  // ──── Navbar ────
  "nav.home": { en: "Home", id: "Beranda" },
  "nav.products": { en: "Products", id: "Produk" },
  "nav.certifications": { en: "Certifications", id: "Sertifikasi" },
  "nav.faq": { en: "FAQ", id: "Tanya Jawab" },
  "nav.about": { en: "About Us", id: "Tentang Kami" },
  "nav.shipping": { en: "Shipping", id: "Pengiriman" },
  "nav.inquiry": { en: "Inquiry", id: "Pertanyaan" },
  "nav.sendInquiry": { en: "Send Inquiry", id: "Kirim Pertanyaan" },
  "nav.closeMenu": { en: "Close navigation menu", id: "Tutup menu navigasi" },
  "nav.openMenu": { en: "Open navigation menu", id: "Buka menu navigasi" },

  // ──── Footer ────
  "footer.exportInquiry": { en: "Export Inquiry", id: "Pertanyaan Ekspor" },
  "footer.tagline": {
    en: "Premium Indonesian herbal products for global partners since 1999.",
    id: "Produk herbal premium Indonesia untuk mitra global sejak 1999.",
  },
  "footer.copyright": { en: "All rights reserved.", id: "Hak cipta dilindungi." },
  "footer.builtFor": { en: "Built for Excellence.", id: "Dibangun untuk Keunggulan." },

  // ──── Hero ────
  "hero.alt.0": { en: "Herbal Powders", id: "Bubuk Herbal" },
  "hero.badge.0": { en: "Herbal Powders", id: "Bubuk Herbal" },
  "hero.heading.0": { en: "Premium", id: "Premium" },
  "hero.highlight.0": { en: "herbal powders", id: "bubuk herbal" },
  "hero.subtext.0": {
    en: "Finely ground herbal powders sourced from Indonesia's finest traditional ingredients, processed with modern quality standards for global export.",
    id: "Bubuk herbal halus dari bahan tradisional terbaik Indonesia, diproses dengan standar kualitas modern untuk ekspor global.",
  },
  "hero.cta.0": { en: "Explore Products", id: "Jelajahi Produk" },
  "hero.alt.1": { en: "Fresh Herbs", id: "Herba Segar" },
  "hero.badge.1": { en: "Fresh Herbs", id: "Herba Segar" },
  "hero.heading.1": { en: "Fresh", id: "Segar" },
  "hero.highlight.1": { en: "quality herbs", id: "herba berkualitas" },
  "hero.subtext.1": {
    en: "Hand-picked fresh herbs from sustainable farms across Indonesia, carefully packaged and shipped globally to preserve natural freshness.",
    id: "Herba segar petik langsung dari pertanian berkelanjutan di Indonesia, dikemas dan dikirim secara global dengan tetap menjaga kesegaran alami.",
  },
  "hero.cta.1": { en: "Explore Products", id: "Jelajahi Produk" },
  "hero.alt.2": { en: "Natural Extracts", id: "Ekstrak Alami" },
  "hero.badge.2": { en: "Natural Extracts", id: "Ekstrak Alami" },
  "hero.heading.2": { en: "Pure", id: "Murni" },
  "hero.highlight.2": { en: "natural extracts", id: "ekstrak alami" },
  "hero.subtext.2": {
    en: "Concentrated herbal extracts crafted using advanced extraction technology, retaining the full potency of nature's finest ingredients.",
    id: "Ekstrak herbal pekat dibuat dengan teknologi ekstraksi canggih, mempertahankan potensi penuh dari bahan alami terbaik.",
  },
  "hero.cta.2": { en: "Explore Products", id: "Jelajahi Produk" },
  "hero.alt.3": { en: "Quality Assurance", id: "Jaminan Mutu" },
  "hero.badge.3": { en: "Quality Assurance", id: "Jaminan Mutu" },
  "hero.heading.3": { en: "Certified", id: "Bersertifikat" },
  "hero.highlight.3": { en: "quality assured", id: "terjamin mutunya" },
  "hero.subtext.3": {
    en: "All products certified Organic, Halal, GMP, and ISO compliant. Rigorous lab testing ensures every shipment meets international standards.",
    id: "Semua produk bersertifikat Organic, Halal, GMP, dan ISO. Pengujian laboratorium ketat memastikan setiap pengiriman memenuhi standar internasional.",
  },
  "hero.cta.3": { en: "View Certifications", id: "Lihat Sertifikasi" },
  "hero.alt.4": { en: "Global Export", id: "Ekspor Global" },
  "hero.badge.4": { en: "Global Export", id: "Ekspor Global" },
  "hero.heading.4": { en: "Worldwide", id: "Seluruh Dunia" },
  "hero.highlight.4": { en: "shipping network", id: "jaringan pengiriman" },
  "hero.subtext.4": {
    en: "Reliable global logistics with FOB/CIF shipping, door-to-door delivery, and dedicated export documentation support for hassle-free international trade.",
    id: "Logistik global yang andal dengan pengiriman FOB/CIF, pengiriman door-to-door, dan dukungan dokumen ekspor untuk perdagangan internasional yang mudah.",
  },
  "hero.cta.4": { en: "Contact Us", id: "Hubungi Kami" },
  "hero.aboutUs": { en: "About Us", id: "Tentang Kami" },
  "hero.slideLabel": { en: "Go to slide {n}", id: "Ke slide {n}" },

  // ──── Navbar Language Toggle ────
  "nav.switchLanguage": { en: "Switch language", id: "Ganti bahasa" },
  "nav.langIndonesia": { en: "Indonesia", id: "Indonesia" },
  "nav.langEnglish": { en: "English", id: "English" },

  // ──── Common Form Messages ────
  "form.loading": { en: "Loading...", id: "Memuat..." },
  "form.submitError": { en: "Failed to submit inquiry. Please try again.", id: "Gagal mengirim pertanyaan. Silakan coba lagi." },

  // ──── Product Categories ────
  "product.powder": { en: "Powder Products", id: "Produk Bubuk" },
  "product.fresh": { en: "Fresh Herbs", id: "Herba Segar" },
  "product.extract": { en: "Extracts", id: "Ekstrak" },
  "product.bean": { en: "Beans", id: "Biji-bijian" },
  "product.leaf": { en: "Leaves", id: "Daun-daunan" },

  // ──── Sample Request Form ────
  "sample.fullName": { en: "Full Name *", id: "Nama Lengkap *" },

  // ──── Homepage Sections ────
  "home.products.title": { en: "Our Products", id: "Produk Kami" },
  "home.products.subtitle": {
    en: "Premium quality natural herbal powders and extracts for global export",
    id: "Bubuk herbal alami dan ekstrak berkualitas premium untuk ekspor global",
  },
  "home.products.viewAll": { en: "View All Products", id: "Lihat Semua Produk" },

  "home.stats.products": { en: "Products", id: "Produk" },
  "home.stats.categories": { en: "Product Categories", id: "Kategori Produk" },
  "home.stats.certifications": { en: "Certifications", id: "Sertifikasi" },
  "home.stats.shipping": { en: "Worldwide Shipping", id: "Pengiriman Global" },

  "home.clients.badge": { en: "Our Partners", id: "Mitra Kami" },
  "home.clients.heading": { en: "Trusted by", id: "Dipercaya oleh" },
  "home.clients.highlight": { en: "Industry Leaders", id: "Pemimpin Industri" },
  "home.clients.subtext": {
    en: "Partnering with leading brands across Southeast Asia to deliver exceptional results.",
    id: "Bermitra dengan merek terkemuka di seluruh Asia Tenggara untuk memberikan hasil yang luar biasa.",
  },

  "home.certifications.title": { en: "Quality Certifications", id: "Sertifikasi Mutu" },
  "home.certifications.subtitle": {
    en: "Our commitment to quality and safety",
    id: "Komitmen kami terhadap kualitas dan keamanan",
  },
  "home.certifications.viewAll": { en: "View All Certifications", id: "Lihat Semua Sertifikasi" },

  "home.shipping.title": { en: "Worldwide Shipping", id: "Pengiriman Global" },
  "home.shipping.subtitle": {
    en: "Reliable global logistics for your export needs",
    id: "Logistik global yang andal untuk kebutuhan ekspor Anda",
  },

  // ──── Products Listing ────
  "products.title": { en: "Our Products", id: "Produk Kami" },
  "products.subtitle": {
    en: "Premium quality natural herbal products for export worldwide",
    id: "Produk herbal alami berkualitas premium untuk ekspor ke seluruh dunia",
  },
  "products.searchPlaceholder": { en: "Search products...", id: "Cari produk..." },
  "products.allCategories": { en: "All Categories", id: "Semua Kategori" },
  "products.gridView": { en: "Grid view", id: "Tampilan grid" },
  "products.listView": { en: "List view", id: "Tampilan daftar" },
  "products.notFound": { en: "No products found.", id: "Produk tidak ditemukan." },
  "products.noCategory": { en: "No Image", id: "Tidak Ada Gambar" },
  "products.count": { en: "Showing {n} product(s)", id: "Menampilkan {n} produk" },
  "products.sortLabel": { en: "Sort by", id: "Urutkan" },
  "products.sortDefault": { en: "Default", id: "Default" },
  "products.sortName": { en: "Name", id: "Nama" },
  "products.sortNewest": { en: "Newest", id: "Terbaru" },
  "products.sortMoq": { en: "MOQ (low)", id: "MOQ (rendah)" },
  "products.clearFilter": { en: "Clear", id: "Hapus" },

  // ──── Product Card ────
  "card.viewDetails": { en: "View Details", id: "Lihat Detail" },
  "card.requestQuote": { en: "Request Quote", id: "Minta Penawaran" },

  // ──── Product Detail ────
  "detail.back": { en: "Back to Products", id: "Kembali ke Produk" },
  "detail.notFound": { en: "Product not found", id: "Produk tidak ditemukan" },
  "detail.moq": { en: "MOQ:", id: "MOQ:" },
  "detail.shelfLife": { en: "Shelf Life:", id: "Masa Simpan:" },
  "detail.storage": { en: "Storage:", id: "Penyimpanan:" },
  "detail.packaging": { en: "Packaging Options", id: "Opsi Kemasan" },
  "detail.packagingFallback": { en: "Custom packaging available", id: "Kemasan kustom tersedia" },
  "detail.certifications": { en: "Certifications", id: "Sertifikasi" },
  "detail.description": { en: "Description", id: "Deskripsi" },
  "detail.specifications": { en: "Specifications", id: "Spesifikasi" },
  "detail.documents": { en: "Download Documents", id: "Unduh Dokumen" },
  "detail.whyUs": { en: "Why Choose Us", id: "Mengapa Memilih Kami" },
  "detail.whyUs.1": { en: "Premium quality assurance", id: "Jaminan kualitas premium" },
  "detail.whyUs.2": { en: "Competitive export pricing", id: "Harga ekspor kompetitif" },
  "detail.whyUs.3": { en: "Flexible MOQ options", id: "Opsi MOQ fleksibel" },
  "detail.whyUs.4": { en: "Worldwide shipping", id: "Pengiriman ke seluruh dunia" },
  "detail.whyUs.5": { en: "Fast response within 24h", id: "Respon cepat dalam 24 jam" },
  "detail.sampleTitle": { en: "Need a Sample?", id: "Butuh Sampel?" },
  "detail.sampleDesc": {
    en: "Request a product sample before placing a bulk order.",
    id: "Minta sampel produk sebelum melakukan pemesanan dalam jumlah besar.",
  },
  "detail.requestSample": { en: "Request Sample", id: "Minta Sampel" },

  // ──── ProductInquiryForm ────
  "inquiry.sent": { en: "Inquiry Sent!", id: "Pertanyaan Terkirim!" },
  "inquiry.respond": { en: "Our team will respond within 24 hours.", id: "Tim kami akan merespon dalam 24 jam." },
  "inquiry.namePlaceholder": { en: "Your Name *", id: "Nama Anda *" },
  "inquiry.emailPlaceholder": { en: "Email Address *", id: "Alamat Email *" },
  "inquiry.qtyPlaceholder": { en: "Quantity Needed", id: "Jumlah Dibutuhkan" },
  "inquiry.messagePlaceholder": { en: "Additional Message", id: "Pesan Tambahan" },
  "inquiry.send": { en: "Send Inquiry", id: "Kirim Pertanyaan" },
  "inquiry.respondWithin": { en: "We usually respond within 24 hours", id: "Kami biasanya merespon dalam 24 jam" },
  "inquiry.title": { en: "Quick Inquiry", id: "Pertanyaan Cepat" },
  "inquiry.desc": {
    en: "Interested in this product? Send us a message.",
    id: "Tertarik dengan produk ini? Kirimkan pesan kepada kami.",
  },
  "inquiry.mobileLabel": { en: "Quick Inquiry", id: "Pertanyaan Cepat" },
  "inquiry.desktopLabel": { en: "Quick Inquiry", id: "Pertanyaan Cepat" },

  // ──── Certifications Page ────
  "certs.title": { en: "Our Certifications", id: "Sertifikasi Kami" },
  "certs.subtitle": {
    en: "CV. Citra Marvella maintains the highest standards of quality and safety. Our products are certified by internationally recognized organizations.",
    id: "CV. Citra Marvella menjaga standar kualitas dan keamanan tertinggi. Produk kami disertifikasi oleh organisasi yang diakui secara internasional.",
  },
  "certs.empty": { en: "No certifications available at this time.", id: "Belum ada sertifikasi saat ini." },

  // ──── FAQ ────
  "faq.title": { en: "Frequently Asked Questions", id: "Pertanyaan yang Sering Diajukan" },
  "faq.subtitle": {
    en: "Find answers to common questions about our export products, ordering process, and shipping.",
    id: "Temukan jawaban untuk pertanyaan umum tentang produk ekspor, proses pemesanan, dan pengiriman.",
  },
  "faq.q0.q": { en: "What is the minimum order quantity (MOQ)?", id: "Berapa jumlah pesanan minimum (MOQ)?" },
  "faq.q0.a": {
    en: "Our standard MOQ varies by product type: Powder products: 100kg, Fresh herbs: 50kg, Extracts: 25kg, Beans: 500kg. We offer flexible MOQ options for new customers with sample orders available.",
    id: "MOQ standar kami bervariasi berdasarkan jenis produk: Produk bubuk: 100kg, Herba segar: 50kg, Ekstrak: 25kg, Biji: 500kg. Kami menawarkan opsi MOQ fleksibel untuk pelanggan baru dengan pesanan sampel tersedia.",
  },
  "faq.q1.q": { en: "What certifications do your products have?", id: "Sertifikasi apa yang dimiliki produk Anda?" },
  "faq.q1.a": {
    en: "Our products are certified Organic, Halal, and meet international food safety standards. We also maintain GMP (Good Manufacturing Practices) and ISO certifications. Specific product certifications vary - please contact us for detailed information.",
    id: "Produk kami bersertifikat Organic, Halal, dan memenuhi standar keamanan pangan internasional. Kami juga memiliki sertifikasi GMP (Good Manufacturing Practices) dan ISO. Sertifikasi produk spesifik bervariasi - silakan hubungi kami untuk informasi detail.",
  },
  "faq.q2.q": { en: "What are your payment terms?", id: "Bagaimana syarat pembayarannya?" },
  "faq.q2.a": {
    en: "We offer flexible payment terms: 30% deposit, 70% before shipment for new customers. For established partners, we provide LC at sight and T/T terms. Sample orders require 100% payment in advance.",
    id: "Kami menawarkan syarat pembayaran fleksibel: 30% deposit, 70% sebelum pengiriman untuk pelanggan baru. Untuk mitra tetap, kami menyediakan LC at sight dan T/T. Pesanan sampel memerlukan pembayaran 100% di muka.",
  },
  "faq.q3.q": { en: "What are your shipping terms and ports?", id: "Apa syarat dan pelabuhan pengiriman Anda?" },
  "faq.q3.a": {
    en: "We ship FOB (Free on Board) and CIF (Cost, Insurance, Freight) terms from our main ports in Jakarta and Surabaya. We work with reputable freight forwarders and can provide Door-to-Door delivery.",
    id: "Kami mengirim dengan syarat FOB (Free on Board) dan CIF (Cost, Insurance, Freight) dari pelabuhan utama kami di Jakarta dan Surabaya. Kami bekerja sama dengan freight forwarder terpercaya dan dapat menyediakan pengiriman Door-to-Door.",
  },
  "faq.q4.q": { en: "How long is the shelf life of your products?", id: "Berapa lama masa simpan produk Anda?" },
  "faq.q4.a": {
    en: "Powder products: 24 months from production date, Fresh herbs: 12 months, Extracts: 24 months when stored properly in cool, dry conditions away from direct sunlight.",
    id: "Produk bubuk: 24 bulan dari tanggal produksi, Herba segar: 12 bulan, Ekstrak: 24 bulan jika disimpan dengan benar di tempat sejuk dan kering, jauh dari sinar matahari langsung.",
  },
  "faq.q5.q": { en: "Can you provide custom packaging?", id: "Apakah Anda menyediakan kemasan kustom?" },
  "faq.q5.a": {
    en: "Yes, we offer customizable packaging solutions: 25kg bags, vacuum packs, cardboard drums, and custom-sized packaging. Minimum order quantity may apply for custom packaging requirements.",
    id: "Ya, kami menyediakan solusi kemasan yang dapat disesuaikan: karung 25kg, kemasan vakum, drum kardus, dan kemasan ukuran kustom. Jumlah pesanan minimum mungkin berlaku untuk kebutuhan kemasan kustom.",
  },
  "faq.q6.q": { en: "How long does sample delivery take?", id: "Berapa lama pengiriman sampel?" },
  "faq.q6.a": {
    en: "Sample processing takes 2-3 business days. International shipping typically takes 5-10 business days via DHL, FedEx, or EMS depending on destination.",
    id: "Pemrosesan sampel memakan waktu 2-3 hari kerja. Pengiriman internasional biasanya memakan waktu 5-10 hari kerja melalui DHL, FedEx, atau EMS tergantung tujuan.",
  },
  "faq.q7.q": {
    en: "Do you provide product specifications and lab reports?",
    id: "Apakah Anda menyediakan spesifikasi produk dan laporan lab?",
  },
  "faq.q7.a": {
    en: "Yes, all our products come with detailed specifications, COA (Certificate of Analysis), and analytical reports. We can also provide custom testing upon request.",
    id: "Ya, semua produk kami dilengkapi dengan spesifikasi detail, COA (Certificate of Analysis), dan laporan analitis. Kami juga dapat menyediakan pengujian kustom sesuai permintaan.",
  },
  "faq.q8.q": { en: "What is your production capacity?", id: "Berapa kapasitas produksi Anda?" },
  "faq.q8.a": {
    en: "We can produce up to 50,000kg of powder products and 20,000kg of fresh herbs per month. Lead time is typically 7-14 days for standard orders and 2-3 weeks for large quantities.",
    id: "Kami dapat memproduksi hingga 50.000kg produk bubuk dan 20.000kg herba segar per bulan. Waktu pengerjaan biasanya 7-14 hari untuk pesanan standar dan 2-3 minggu untuk jumlah besar.",
  },
  "faq.q9.q": { en: "How do I place a sample order?", id: "Bagaimana cara memesan sampel?" },
  "faq.q9.a": {
    en: "You can request samples through our Sample Request page. Specify the products you want, quantities, and packaging preferences. Our team will contact you within 24 hours with a quote.",
    id: "Anda dapat meminta sampel melalui halaman Permintaan Sampel. Sebutkan produk yang diinginkan, jumlah, dan preferensi kemasan. Tim kami akan menghubungi Anda dalam 24 jam dengan penawaran harga.",
  },
  "faq.stillQuestions": { en: "Still Have Questions?", id: "Masih Punya Pertanyaan?" },
  "faq.contactDesc": {
    en: "Our export team is ready to assist you with any questions about our products or services.",
    id: "Tim ekspor kami siap membantu Anda dengan pertanyaan tentang produk atau layanan kami.",
  },
  "faq.contactUs": { en: "Contact Us", id: "Hubungi Kami" },
  "faq.whatsapp": { en: "WhatsApp Support", id: "Dukungan WhatsApp" },

  // ──── About Us Page ────
  "about.heroBadge": { en: "About Citra Marvella", id: "Tentang Citra Marvella" },
  "about.heroHeading": { en: "Premium Herbs.", id: "Herbal Premium." },
  "about.heroHighlight": { en: "Global Trust.", id: "Kepercayaan Global." },
  "about.heroFallback": {
    en: "A trusted Indonesian herbal exporter since 1999, delivering premium quality herbs and spices to B2B buyers across the globe.",
    id: "Eksportir herbal Indonesia terpercaya sejak 1999, mengirimkan herbal dan rempah berkualitas premium ke pembeli B2B di seluruh dunia.",
  },
  "about.exploreProducts": { en: "Explore Products", id: "Jelajahi Produk" },
  "about.whoWeAre": { en: "Who We Are", id: "Siapa Kami" },
  "about.trustedExporter": { en: "Trusted Herbal Exporter Since 1999", id: "Eksportir Herbal Terpercaya Sejak 1999" },
  "about.descFallback": {
    en: "CV. Citra Marvella has been a trusted name in Indonesia's herbal industry since 1999. We specialize in sourcing, processing, and exporting premium herbal products including powders, fresh herbs, extracts, and spices to B2B buyers worldwide. Our facilities maintain the highest international quality standards, and every product is processed with clean, hygienic methods.",
    id: "CV. Citra Marvella telah menjadi nama terpercaya di industri herbal Indonesia sejak 1999. Kami mengkhususkan diri dalam pengadaan, pemrosesan, dan ekspor produk herbal premium termasuk bubuk, herba segar, ekstrak, dan rempah ke pembeli B2B di seluruh dunia. Fasilitas kami mempertahankan standar kualitas internasional tertinggi, dan setiap produk diproses dengan metode yang bersih dan higienis.",
  },
  "about.viewProducts": { en: "View all products", id: "Lihat semua produk" },
  "about.satisfaction": { en: "Your Satisfaction", id: "Kepuasan Anda" },
  "about.satisfactionHighlight": { en: "Is Our Priority", id: "Adalah Prioritas Kami" },
  "about.whatDrivesUs": { en: "What Drives Us", id: "Apa yang Mendorong Kami" },
  "about.coreValues": { en: "Our Core Values", id: "Nilai-nilai Inti Kami" },
  "about.ourDirection": { en: "Our Direction", id: "Arah Kami" },
  "about.visionMission": { en: "Vision & Mission", id: "Visi & Misi" },
  "about.vision": { en: "Vision", id: "Visi" },
  "about.visionFallback": {
    en: "To be the world's preferred partner for premium Indonesian herbal products, recognized for quality, reliability, and sustainable practices.",
    id: "Menjadi mitra pilihan dunia untuk produk herbal premium Indonesia, diakui atas kualitas, keandalan, dan praktik berkelanjutan.",
  },
  "about.mission": { en: "Mission", id: "Misi" },
  "about.letsWork": { en: "Let's Work Together", id: "Mari Bekerja Sama" },
  "about.ctaHeading": { en: "Ready to Source", id: "Siap Mencari" },
  "about.ctaHighlight": { en: "Premium Herbs?", id: "Herbal Premium?" },
  "about.ctaDesc": {
    en: "Whether you need herbal powders, fresh herbs, extracts, or private label solutions — our export team is ready to serve you.",
    id: "Apakah Anda membutuhkan bubuk herbal, herba segar, ekstrak, atau solusi label pribadi — tim ekspor kami siap melayani Anda.",
  },
  "about.startConversation": { en: "Start a Conversation", id: "Mulai Percakapan" },
  "about.browseProducts": { en: "Browse Products", id: "Jelajahi Produk" },

  // ──── Sample Request ────
  "sample.title": { en: "Request Samples", id: "Minta Sampel" },
  "sample.subtitle": {
    en: "Request product samples to evaluate quality before placing bulk orders",
    id: "Minta sampel produk untuk mengevaluasi kualitas sebelum melakukan pemesanan dalam jumlah besar",
  },
  "sample.submittedTitle": { en: "Thank You!", id: "Terima Kasih!" },
  "sample.submittedBody": {
    en: "Your sample request has been submitted successfully.",
    id: "Permintaan sampel Anda telah berhasil dikirim.",
  },
  "sample.important": { en: "Important:", id: "Penting:" },
  "sample.feeQuote": { en: "Sample fees will be quoted within 24 hours", id: "Biaya sampel akan diberikan dalam 24 jam" },
  "sample.shippingSeparate": {
    en: "Shipping costs are calculated separately",
    id: "Biaya pengiriman dihitung terpisah",
  },
  "sample.contactPayment": {
    en: "Our team will contact you for payment details",
    id: "Tim kami akan menghubungi Anda untuk detail pembayaran",
  },
  "sample.deliveryTime": { en: "Average sample delivery: 5-10 business days", id: "Rata-rata pengiriman sampel: 5-10 hari kerja" },
  "sample.requestAnother": { en: "Request Another Sample", id: "Minta Sampel Lain" },
  "sample.sampleProducts": { en: "Sample Products *", id: "Produk Sampel *" },
  "sample.helpDesktop": {
    en: "Recommended: 3-5 different products for comprehensive evaluation",
    id: "Disarankan: 3-5 produk berbeda untuk evaluasi menyeluruh",
  },
  "sample.helpMobile": {
    en: "Tap to select, tap again to deselect. Select 3-5 products recommended.",
    id: "Ketuk untuk memilih, ketuk lagi untuk membatalkan. Pilih 3-5 produk disarankan.",
  },
  "sample.qtyLabel": { en: "Quantity per Sample (grams)", id: "Jumlah per Sampel (gram)" },
  "sample.qtyPlaceholder": { en: "e.g., 100g each", id: "mis., 100g masing-masing" },
  "sample.requirements": { en: "Requirements & Preferences", id: "Kebutuhan & Preferensi" },
  "sample.requirementsPlaceholder": {
    en: "Specify packaging preferences, intended use, and any special requirements",
    id: "Sebutkan preferensi kemasan, penggunaan yang dimaksud, dan kebutuhan khusus",
  },
  "sample.policy": { en: "Sample Policy", id: "Kebijakan Sampel" },
  "sample.policy1": { en: "Minimum sample package: 3 products (100g each)", id: "Paket sampel minimum: 3 produk (100g masing-masing)" },
  "sample.policy2": { en: "Sample fees apply based on quantity and products", id: "Biaya sampel berlaku berdasarkan jumlah dan produk" },
  "sample.policy3": { en: "Shipping costs calculated at checkout", id: "Biaya pengiriman dihitung saat checkout" },
  "sample.policy4": {
    en: "Sample fees deductible from first bulk order",
    id: "Biaya sampel dapat dikurangkan dari pesanan besar pertama",
  },
  "sample.policy5": { en: "Processing time: 2-3 business days", id: "Waktu pemrosesan: 2-3 hari kerja" },
  "sample.submitting": { en: "Submitting...", id: "Mengirim..." },
  "sample.submit": { en: "Request Samples", id: "Minta Sampel" },
  "sample.loading": { en: "Loading...", id: "Memuat..." },
  "sample.nameLabel": { en: "Full Name *", id: "Nama Lengkap *" },
  "sample.emailLabel": { en: "Email Address *", id: "Alamat Email *" },
  "sample.companyLabel": { en: "Company Name", id: "Nama Perusahaan" },
  "sample.countryLabel": { en: "Country *", id: "Negara *" },
  "sample.selectCountry": { en: "Select your country", id: "Pilih negara Anda" },
  "sample.requirementsLabel": { en: "Requirements & Preferences", id: "Kebutuhan & Preferensi" },

  // ──── Landing Page ────
  "landing.title": { en: "Welcome to Citra Marvella Export Portal", id: "Selamat Datang di Portal Ekspor Citra Marvella" },
  "landing.aboutTitle": { en: "About CV. Citra Marvella", id: "Tentang CV. Citra Marvella" },
  "landing.aboutP1": {
    en: "Established in 1999, CV. Citra Marvella has been a trusted producer of high-quality natural herbal products. We specialize in exporting premium Indonesian herbal powders, fresh herbs, and extracts to customers worldwide.",
    id: "Didirikan pada tahun 1999, CV. Citra Marvella telah menjadi produsen terpercaya produk herbal alami berkualitas tinggi. Kami mengkhususkan diri dalam mengekspor bubuk herbal premium Indonesia, herba segar, dan ekstrak ke pelanggan di seluruh dunia.",
  },
  "landing.aboutP2": {
    en: "Our facilities maintain international quality standards, and all products are processed using clean, hygienic methods to ensure the highest quality for our global customers.",
    id: "Fasilitas kami mempertahankan standar kualitas internasional, dan semua produk diproses menggunakan metode bersih dan higienis untuk memastikan kualitas terbaik bagi pelanggan global kami.",
  },
  "landing.whyTitle": { en: "Why Choose Us for Export?", id: "Mengapa Memilih Kami untuk Ekspor?" },
  "landing.why1": { en: "Natural Indonesian ingredients", id: "Bahan alami Indonesia" },
  "landing.why2": { en: "25+ years of experience", id: "25+ tahun pengalaman" },
  "landing.why3": { en: "International quality standards", id: "Standar kualitas internasional" },
  "landing.why4": { en: "Flexible MOQ and packaging", id: "MOQ dan kemasan fleksibel" },
  "landing.why5": { en: "Fast sample delivery", id: "Pengiriman sampel cepat" },
  "landing.why6": { en: "Competitive wholesale pricing", id: "Harga grosir kompetitif" },
  "landing.cardProducts": { en: "Browse Products", id: "Jelajahi Produk" },
  "landing.cardProductsDesc": { en: "Explore our full catalog of export-ready products", id: "Jelajahi katalog lengkap produk siap ekspor kami" },
  "landing.cardCerts": { en: "View Certifications", id: "Lihat Sertifikasi" },
  "landing.cardCertsDesc": { en: "Learn about our quality certifications", id: "Pelajari tentang sertifikasi mutu kami" },
  "landing.cardFaq": { en: "FAQ", id: "FAQ" },
  "landing.cardFaqDesc": { en: "Common questions about export orders", id: "Pertanyaan umum tentang pesanan ekspor" },
  "landing.ctaTitle": { en: "Ready to Start Your Export Journey?", id: "Siap Memulai Perjalanan Ekspor Anda?" },
  "landing.ctaDesc": {
    en: "Contact our export team to discuss your requirements and receive a customized quote.",
    id: "Hubungi tim ekspor kami untuk mendiskusikan kebutuhan Anda dan menerima penawaran yang disesuaikan.",
  },
  "landing.requestQuote": { en: "Request Quote", id: "Minta Penawaran" },
  "landing.whatsappUs": { en: "WhatsApp Us", id: "Hubungi WhatsApp" },

  // ──── Export Inquiry (additional keys) ────
  "export.submitError": {
    en: "Failed to submit inquiry. Please try again.",
    id: "Gagal mengirim pertanyaan. Silakan coba lagi.",
  },
  "export.loading": { en: "Loading...", id: "Memuat..." },

  // ──── Cookie Consent ────
  "cookie.title": { en: "Cookie Consent", id: "Persetujuan Cookie" },
  "cookie.body": {
    en: "We use cookies to improve your browsing experience, personalize ads or content, and analyze our traffic. By selecting \"Accept All\", you consent to the use of cookies.",
    id: "Kami menggunakan cookies untuk meningkatkan pengalaman Anda saat menjelajah situs, memberikan personalisasi iklan atau konten, dan menganalisis traffic kami. Dengan memilih \"Terima Semua\", Anda mengizinkan penggunaan cookies.",
  },
  "cookie.decline": { en: "Decline", id: "Tolak" },
  "cookie.accept": { en: "Accept All", id: "Terima Semua" },
  "cookie.preferences": {
    en: "You can change your cookie preferences at any time through your browser settings.",
    id: "Anda dapat mengubah preferensi cookies kapan saja melalui pengaturan browser.",
  },
  "lang.id": { en: "Indonesian", id: "Indonesia" },
  "lang.en": { en: "English", id: "Inggris" },
};

export function t(locale: "en" | "id", key: string, params?: Record<string, string>): string {
  const entry = translations[key];
  if (!entry) return key;
  let text = entry[locale];
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      text = text.replace(`{${k}}`, v);
    }
  }
  return text;
}
